module.exports = __webpack_public_path__ + "static/media/11NEPAD10.9e1fd328.jpg";